import React from 'react';
import { createUseStyles } from 'react-jss';
import ChevronToggle from '../ChevronToggle';
import BaseInput, { FocusEvent } from './BaseInput';

// style =====================================

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    position: 'relative',
  },
  numberControls: {
    display: 'flex',
    alignItems: 'stretch',
    position: 'absolute',
    height: '100%',
    right: 0,
    paddingRight: 5,
  },
});

type Props = {
  title?: string;
  name?: string;
  value?: string | number;
  error?: string;
  onChange?: (value: string | number) => void;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;

  autoFocus?: boolean;
  autoComplete?: boolean;
  type?: 'password' | 'number' | 'tel' | 'email';
  min?: number;
  testId?: string;
};

const TextField = (props: Props) => {
  const {
    title,
    name,
    value,
    error,
    onChange = () => {},
    onFocus = () => {},
    onBlur = () => {},

    autoFocus = false,
    autoComplete = false,
    type,
    min = 0,
    testId,
  } = props;

  const classes = useStyles();

  return (
    <BaseInput
      title={title}
      value={value}
      error={error}
      onFocus={onFocus}
      onBlur={onBlur}
      testId={testId}
    >
      {baseProps => (
        <div className={classes.container}>
          {type === 'number' && (
            <div className={classes.numberControls}>
              <ChevronToggle
                width={35}
                size="small"
                direction="vertical"
                onClickLeft={() => onChange(Number(value) + 1)}
                onClickRight={() => onChange(Math.max(min, Number(value) - 1))}
              />
            </div>
          )}
          <input
            name={name}
            value={value}
            onChange={e => onChange(e.target.value)}
            onFocus={baseProps.onFocus}
            onBlur={baseProps.onBlur}
            autoFocus={autoFocus}
            autoComplete={autoComplete ? 'true' : ''}
            type={type}
            className={baseProps.inputClassName}
          />
        </div>
      )}
    </BaseInput>
  );
};

export default TextField;
